export default {
  home: 'Home',
  details: 'Details',
  notFound: 'Not found',
  conferenceScreen: {
    you: 'You',
    muteAll: 'Mute all',
    youAreScreenSharing: 'You are screen sharing',
    stopShare: 'Stop share',
    class: 'class',
    hideParticipants: 'Hide participants',
    showParticipants: 'Show participants',
    unexpectedProblemTryToReconnect: 'Cannot connect you. Try again please',
    severalScreensCannotBeShownSimultaneously:
      'Several screens cannot be shown simultaneously',
    reactions: {
      raiseHand: '✋      Raise hand',
    },
    participants: {
      title: 'Participants',
      me: 'me',
    },
    classRecordRequest: 'Record request',
  },
  tabbar: {
    classes: 'Classes',
    analytics: 'Analytics',
    profile: 'Profile',
    adminPanel: 'Admin panel',
  },
  adminPanelTabbar: {
    general: 'General',
    teachers: 'Teachers',
    groups: 'Groups',
  },
  chat: {
    you: 'You',
    inputPlaceholder: 'Type a message...',
    title: 'Chat',
  },
  loginScreen: {
    title: 'UClass',
    subTitle: 'Organize better classes right now',
  },
  shared: {
    signInGoogle: 'Sign in With Google',
    done: 'Done',
    hours: 'hours',
    min: 'min',
    cancel: 'Cancel',
  },
  homeScreen: {
    greeting: 'Hi',
    greetQuestion: 'How’re you today?',
    joinLesson: 'Join',
    allLessons: 'All Classes',
    current: 'Current',
    scheduled: 'Scheduled',
    create: 'Create class',
    lesson: 'lesson',
    cancelLesson: 'Cancel lesson for today',
    deleteLesson: 'Delete lesson from system',
    phoneButtonToday: 'Today',
  },
  calendarTitles: {
    buttonTitle: 'Jump to day',
    weekdaysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    monthsFull: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    webButtonToday: 'Today',
  },
  createClassScreen: {
    subject: 'Subject',
    language: 'Language',
    group: 'Group',
    startDate: 'Start date',
    endDate: 'End date',
    duration: 'Duration',
    chooseSubjectTitle: 'Choose subject',
    chooseLanguageTitle: 'Choose language',
    chooseGroupTitle: 'Choose group',
    chooseDurationTitle: 'Choose class duration',
    createClass: 'Create class',
    days: 'Days',
    addTime: 'Add time',
    chooseDay: 'Choose day',
    scheduleClass: 'Schedule class',
    oneMoreClass: 'One more class',
  },
  profile: {
    profilePhoto: 'Profile photo',
    logOut: 'Log out',
    deleteAccount: 'Delete account',
    appVersion: 'App version',
    save: 'Save',
    deletePhoto: 'Delete photo',
  },
  analyticsScreen: {
    dateAndClass: 'Date and class',
    showAnalytics: 'Show analytics',
    analytics: 'Analytics',
    attendees: 'Attendees',
    seeAll: ' See all',
    transcriptions: 'Transcriptions',
    charts: 'Charts',
    analyticType: 'Analytic type',
    student: 'Student',
    chooseAnalyticTypeTitle: 'Choose analytic type',
    chooseStudent: 'Choose student',
    inProgress: 'In progress',
    error: 'Error',
    cancelled: 'Cancelled',
    notStarted: 'Not started',
    completed: 'Completed',
    view: 'View',
    status: 'Status',
    speakers: 'Speakers',
    reaction: 'Reaction',
    attention: 'Attention',
    subject: 'Subject',
    time: 'Time',
  },
  popup: {
    error: 'Error',
    success: 'Success',
  },
  errors: {
    userNotFoundInTheSystem:
      'This user was not found in the system or unauthorized.',
    errorRecording: 'Something went wrong! Try again later.',
  },
  admin: {
    general: 'General',
    teachers: 'Teachers',
    createGroup: 'Create group',
    editGroup: 'Edit group',
    groupInfo: 'Group information',
    groupName: 'Group name',
    students: 'Students',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    group: 'Groups',
    cancel: 'Cancel',
    schoolName: 'School name',
    schoolAddress: 'School address',
    directorName: 'Director name',
    directorEmail: 'Director email',
  },
  successes: {
    successRecording:
      'Your request is accepted! You will receive an email with a link to the recording as soon as it is ready.',
  },
};
